import { Button, ButtonProps } from '@mui/material';
import { extractErrorMessage } from 'app/providers/with-wagmi-auth/utils';
import { paymentModel } from 'entities/payment';
import { COLOR_BG_BLACK, COLOR_PRIMARY, getToastMessage, useAppDispatch, useStepper } from 'shared';
import { STEPPER_ROUTES } from 'widgets/buy-package/lib/stepper';

interface CancelOrderButtonProps {
  id: number;
}

export const CancelOrderButton = ({ id, ...props }: CancelOrderButtonProps & Omit<ButtonProps, 'onClick' | 'id'>) => {
  const dispatch = useAppDispatch();
  const { replace } = useStepper();

  const handleCancelOrder = async () => {
    try {
      await dispatch(paymentModel.thunks.cancelPayment(id)).unwrap();
      getToastMessage('success', 'Your payment has been cancelled');
      replace(STEPPER_ROUTES.PAYMENT_INITIAL);
    } catch (error) {
      getToastMessage('error', extractErrorMessage(error));
    }
  };

  return (
    <Button
      fullWidth
      size="medium"
      sx={{ color: COLOR_PRIMARY, bgcolor: COLOR_BG_BLACK, '&:hover': { color: COLOR_BG_BLACK } }}
      onClick={handleCancelOrder}
      {...props}
    >
      Cancel order
    </Button>
  );
};
